// extracted by css-extract-rspack-plugin
export default {"importHomeCard":"TIbF6","clickable":"hOjk7","content":"_1zoVj","iconWrap":"-Fzlc","icon":"_3frJx","title":"_28XqM","description":"_3yAEu","actionRow":"_2hMda","btn":"_2AvPc"};